<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-user-dropdown
      name="privateUsers"
      formControlName="privateUsers"></app-user-dropdown>
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'title'"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper
      *ngIf="
        !itemToEdit ||
        (itemToEdit &&
          this.activeUserStore.user() &&
          itemToEdit.user === this.activeUserStore.user()?._id)
      "
      [colSize]="4"
      [label]="'Privat'"
      [name]="'private'"
      [floatingLabel]="true">
      <p-inputSwitch id="private" formControlName="private"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>

  <p-divider />
  <div class="grid">
    <app-workspace-dropdown
      name="workspaces"
      type="bookmarkCategory"
      formControlName="workspaces"></app-workspace-dropdown>
  </div>
  <p-divider />

  <app-header
    text="Welche Ansichten sollen diesem Bereich zugeordnet werden?"
    icon="fas fa-note-sticky"></app-header>
  <div class="card" *ngIf="bookmarkStore.initialized()">
    <p-pickList
      class="app-pick-list"
      [source]="bookmarks"
      [target]="categoryBookmarks"
      [showSourceControls]="false"
      [dragdrop]="true"
      [responsive]="true"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      filterBy="title"
      sourceFilterPlaceholder="Suche"
      targetFilterPlaceholder="Suche"
      breakpoint="1400px"
      (onMoveToSource)="updateFormValue()"
      (onMoveToTarget)="updateFormValue()"
      (onTargetReorder)="updateFormValue()"
      (onMoveAllToSource)="updateFormValue()"
      (onMoveAllToTarget)="updateFormValue()">
      <ng-template pTemplate="sourceHeader">
        <app-pick-list-header title="Ansichten" [count]="bookmarks.length" />
      </ng-template>
      <ng-template pTemplate="targetHeader">
        <app-pick-list-header
          title="In diesem Themenbereich"
          [count]="categoryBookmarks.length" />
      </ng-template>
      <ng-template let-bookmark pTemplate="item">
        @if (bookmark) {
          <div class="pl-row">
            <i class="fas fa-note-sticky pl-icon"></i>
            <div class="pl-body">
              <span class="pl-name">{{ bookmark.title }}</span>
              @if (bookmarkConflicts[bookmark._id]; as conflictTitles) {
                <span class="pl-meta pl-warning">
                  <i class="fas fa-triangle-exclamation mr-1"></i>
                  bereits in „{{ conflictTitles }}“
                </span>
              }
            </div>
          </div>
        }
      </ng-template>
      <ng-template pTemplate="emptymessagesource">
        <div class="pl-empty">Keine weiteren Einträge.</div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagesource">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
      <ng-template pTemplate="emptymessagetarget">
        <div class="pl-empty">
          Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen
          übernehmen.
        </div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagetarget">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
    </p-pickList>
  </div>
  <p-divider />
  <app-form-footer
    [cancelLevel]="cancelLevel"
    (cancel)="cancel.emit()"
    [hideCancelLink]="disableCancelLink"
    [showRemoveButton]="
      !!itemToEdit &&
      permissionService.checkBookmarkRights(itemToEdit._id, 'remove')
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
